import { defineComponent } from 'vue';
import BaseSocials from '../../mixins/BaseSocial/BaseSocial.js';
import getSerialisedParams from '../../utils/getSerialisedParams.js';
import getSeparatedList from '../../utils/getSeparatedList.js';

/**
 * Hey!
 *
 * SHouzz component used for Houzz social network
 * @link https://www.houzz.com/
 */
/**
 * Share parameters for link
 * @link https://www.houzz.com/buttonsAndBadges/button#houzzbuttondocs
 */

var SHouzz = /* #__PURE__ */defineComponent({
  name: 'SHouzz',
  mixins: [BaseSocials('Houzz', {
    width: 1100,
    height: 700
  })],
  computed: {
    networkURL: function networkURL() {
      var BASE_URL = 'https://www.houzz.com/imageClipperUpload';
      var shareOptions = this.shareOptions;
      var id = shareOptions.id,
          url = shareOptions.url,
          title = shareOptions.title,
          image = shareOptions.image,
          category = shareOptions.category;
      var serialisedParams = getSerialisedParams({
        link: url,
        hzid: id,
        imageUrl: image,
        title: title,
        category: getSeparatedList(category)
      });
      return "".concat(BASE_URL).concat(serialisedParams);
    }
  },
  render: function render() {
    return this.generateComponent(this.networkURL);
  }
});

export default SHouzz;
